import { BaseComponent } from '../base-component'
import { $el, $list } from 'src/scripts/utils/utils'
import { isMobile } from 'src/scripts/utils/check-media'
import { CarouselComponent, CarouselDots } from '../carousel'
import { debounce } from 'src/scripts/utils/debounce'

export class TestimonialsComponent extends BaseComponent {
  resizeObserver: ResizeObserver
  blockId: string
  gridElements: HTMLElement[]
  carousels: CarouselComponent[]

  mountComponent(): void {
    if (!this.isEditor) {
      return
    }

    this.gridElements = $list('quote-component', this)
    this.carousels = $list('carousel-component', this)

    this.carousels.forEach(carousel => {
      carousel.editor.destroy()
      carousel.handleBlockSelect = this.handleBlockSelect
    })

    this.editor.on('BLOCK_SELECT', this.handleBlockSelect)
    this.editor.on('SECTION_LOAD', this.handleSectionLoad)

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this)

    if (this.blockId) {
      this.scrollToSelectedBlock()
    }
  }

  handleSectionLoad = () => {
    if (this.blockId) {
      this.scrollToSelectedBlock()
    }
  }

  handleBlockSelect = ({ detail: { sectionId, blockId, load } }) => {
    if (this.dataset.sectionId !== sectionId) {
      return
    }

    this.blockId = blockId
    this.scrollToSelectedBlock()
  }

  handleResize = debounce(() => {
    if (this.blockId) {
      this.scrollToSelectedBlock()
    }
  }, 100)

  scrollToSelectedBlock = () => {
    const isGrid =
      (!isMobile() && this.dataset.desktopLayout.includes('grid')) ||
      (isMobile() && this.dataset.mobileLayout.includes('column'))

    if (isGrid) {
      this.scrollGrid()
    } else {
      this.scrollCarousel()
    }
  }

  scrollCarousel = () => {
    const carousel = $list('carousel-component', this).filter(
      carousel => carousel.offsetWidth > 0,
    )[0] as CarouselComponent

    const dots = $el('carousel-dots', carousel) as CarouselDots

    const slides = carousel.embla.slideNodes()

    const slideIndex = slides.findIndex(
      ({ attributes }) => attributes['block-id']?.value === this.blockId,
    )

    const scrollToIndex =
      slideIndex % +this.dataset.desktopColumns === 0
        ? Math.floor(slideIndex / +this.dataset.desktopColumns)
        : Math.floor((slideIndex - 1) / +this.dataset.desktopColumns)

    if (scrollToIndex !== -1) {
      carousel.embla.scrollTo(isMobile() ? slideIndex : scrollToIndex, false)
      carousel.stop()
      dots?.handleCarouselSelect()
    }
  }

  scrollGrid = () => {
    const grid = this.gridElements.filter(el => el.offsetWidth > 0)

    const block = grid.find(
      ({ attributes }) => attributes['block-id']?.value === this.blockId,
    )

    block?.scrollIntoView({ block: 'center', behavior: 'smooth' })
  }
}
